export * from "./shared";

/**
 * WEB ONLY *in this module* — apps/mobile `utils/regex.js` has no such export.
 *
 * ⚠️ Mobile has the identical function under the identical name in `utils/validator`
 * (`@rista/core/utils/validator/index.native.ts`). It is NOT missing on mobile and it is NOT a
 * platform difference in behaviour — only in which file each app declared it. Keeping each copy
 * in its own app's module is what leaves every existing import path untouched.
 */
export const isValidPhoneNumber = (number: string) => {
  return /^[6-9]\d{9}$/.test(number);
};
